'use strict';

app.directive('rmGauge', function ($compile) {
  var svg = '<svg><path ng-attr-d="M 36 4 A 32 32 0 {{ flag }} 1 {{ x }} {{ y }}" /></svg>';
  return {
    scope: {
      value: '=rmGauge'
    },
    restrict: 'A',
    link: function (scope, element) {
      var dom = angular.element(svg);
      $compile(dom)(scope);
      element.addClass('rm-gauge').append(dom);
      scope.$watch('value', function (value) {
        value = value || 0;
        var angle = Math.PI * ( 1 / 2  - 2 * value / 100.01);
        scope.flag = value > 50 ? 1 : 0;
        scope.x = 36 + 32 * Math.cos(angle);
        scope.y = 36 - 32 * Math.sin(angle);
      });
    }
  };
});
